import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
  },
  center: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  flex2: {
    flex: 2,
  },
  flex1: {
    flex: 1,
  },
  flex3: {
    flex: 3,
  },
  flexCustom: {
    flex: 0.6,
  },
  columnFlex: { flexDirection: 'column' },
});
